<template>
  <div class="tariff-contract">
    <div v-if="isContractsLoading" class="tariff-contract-none">
      <img src="@icons/bubble-loader.svg" width="40" />
    </div>

    <div v-else-if="hasContract" class="tariff-contract-wrapper">
      <div class="tariff-contract-aside">
        <div class="tariff-contract-aside__card">
          <div v-if="isContractDataLoading" class="tariff-contract-aside__loader-overlay">
            <img class="tariff-contract-aside__loader-icon" src="@icons/bubble-loader.svg" width="40" />
          </div>
          <template v-else>
            <div
              class="tariff-contract-documents scroll scroll--rounded"
              :class="{ 'tariff-contract-documents--disabled': documentLoading }"
            >
              <ContractDocumentSelector
                :contracts="contracts"
                :selected-id="selectedContractId"
                :contract-status="contractStatusComponent"
                @select="setSelectedContractId"
              />

              <div v-if="contracts.length" class="tariff-contract-aside__divider"></div>

              <div
                v-if="pinnedDocument"
                class="tariff-contract-document first"
                @click="
                  showDocument(
                    pinnedDocument.doc_id,
                    pinnedDocument.form_id,
                    pinnedDocument.contract_id,
                    pinnedDocument.guid
                  )
                "
              >
                <div
                  class="tariff-contract-document__body"
                  :class="{
                    'tariff-contract-document--active': pinnedDocument.guid === activeDocumentId,
                  }"
                >
                  <div class="tariff-contract-document__body__title">
                    {{ pinnedDocument?.name }}
                    <span v-if="pinnedDocument?.subtitle" class="tariff-contract-document__body__subtitle">{{
                      pinnedDocument?.subtitle
                    }}</span>
                  </div>
                  <FileDownloadIcon
                    :contract-id="pinnedDocument.contract_id"
                    :form-id="pinnedDocument.form_id"
                    :doc-id="pinnedDocument.doc_id"
                    class="tariff-contract-document-icon"
                  />
                </div>

                <div
                  v-for="item in pinnedDocument.next_doc"
                  :key="item.guid"
                  class="tariff-contract-document__details"
                  :class="{ 'tariff-contract-document--active': item.guid === activeDocumentId }"
                  @click.stop="showDocument(item.doc_id, item.form_id, item.contract_id, item.guid)"
                >
                  <span class="tariff-contract-document__details__notify" :class="{ visible: !item.actualy }"></span>
                  <span class="tariff-contract-document__details__title">
                    Редакция с {{ formatDate(item.date, "dd.MM.yy") }}
                  </span>
                  <FileDownloadIcon
                    :contract-id="item.contract_id"
                    :form-id="item.form_id"
                    :doc-id="item.doc_id"
                    class="tariff-contract-document-icon"
                  />
                </div>
              </div>

              <div v-if="documents.length > 1" class="tariff-contract-aside__divider"></div>

              <div
                v-for="document in documents.slice(1)"
                :key="document.guid"
                class="tariff-contract-document"
                @click="showDocument(document.doc_id, document.form_id, document.contract_id, document.guid)"
              >
                <div
                  class="tariff-contract-document__body"
                  :class="{
                    'tariff-contract-document--active': document.guid === activeDocumentId,
                  }"
                >
                  <div class="tariff-contract-document__body__title">
                    {{ document?.name }}
                    <span v-if="document?.subtitle" class="tariff-contract-document__body__subtitle">{{
                      document?.subtitle
                    }}</span>
                  </div>
                  <FileDownloadIcon
                    :contract-id="document.contract_id"
                    :form-id="document.form_id"
                    :doc-id="document.doc_id"
                    class="tariff-contract-document-icon"
                  />
                </div>

                <div
                  v-for="item in document.next_doc"
                  :key="item.guid"
                  class="tariff-contract-document__details"
                  :class="{ 'tariff-contract-document--active': item.guid === activeDocumentId }"
                  @click.stop="showDocument(item.doc_id, item.form_id, item.contract_id, item.guid)"
                >
                  <span class="tariff-contract-document__details__notify" :class="{ visible: !item.actualy }"></span>
                  <span class="tariff-contract-document__details__title">
                    Редакция с {{ formatDate(item.date, "dd.MM.yy") }}
                  </span>
                  <FileDownloadIcon
                    :contract-id="item.contract_id"
                    :form-id="item.form_id"
                    :doc-id="item.doc_id"
                    class="tariff-contract-document-icon"
                  />
                </div>
              </div>

              <div class="tariff-contract-aside__divider"></div>

              <template v-if="documents.find((document) => document.rules)">
                <a
                  href="https://1cbo.ru/rates_and_services/offer2/"
                  class="tariff-contract-document all"
                  target="_blank"
                >
                  <span>Правила обслуживания</span>
                  <img src="@icons/external-link.svg" alt="external-link.svg" />
                </a>
              </template>
            </div>

            <MarginConfirmationBlock
              v-if="['concluding', 'concluding_expect'].includes(contractStatusComponent)"
              class="tariff-contract-aside__confirmation"
              use-selected-contract
            />

            <div class="tariff-contract-documents-all" @click.stop="downloadFile">
              <span>Скачать комплект документов</span>
              <img v-if="!fullPackDocLoading" src="../../assets/icons/documents/download.svg" alt="download.svg" />
              <img v-else class="tariff-contract-documents-all__loader" src="@icons/bubble-loader.svg" width="20" />
            </div>
          </template>
        </div>
      </div>

      <div class="tariff-contract-main scroll">
        <div class="tariff-contract-info">
          <div class="tariff-contract-status">
            <div v-if="isContractDataLoading" class="tariff-contract-status__loader">
              <img class="tariff-contract-status__loader-icon" src="@icons/bubble-loader.svg" width="40" />
            </div>
            <template v-else>
              <div class="tariff-contract-status-col tariff-contract-status-col--status">
                <AppIcon
                  v-if="statuses[contractStatusComponent].icon"
                  :src="statuses[contractStatusComponent].icon"
                  class="tariff-contract-status-icon"
                />

                <div class="tariff-contract-status-right__column">
                  <div class="tariff-contract-status-text" :style="{ color: statuses[contractStatusComponent].color }">
                    <AppIcon
                      :key="statusTextIconName"
                      :name="statusTextIconName"
                      class="tariff-contract-status-text-icon"
                    />
                    <span v-if="contractStatusComponent === 'suspended' || contractStatusComponent === 'terminated'">
                      {{ statuses[contractStatusComponent].title }}
                      <span v-if="contractInfo?.status_date"> с {{ contractInfo.status_date | localDate }} </span>
                    </span>
                    <span v-else>{{ statuses[contractStatusComponent].title }}</span>
                  </div>
                  <div class="relative">
                    <div class="tariff-contract-history-link" @click="openContractHistory">История действий</div>

                    <FadeTransaction>
                      <div
                        v-if="Object.keys(isOpenContractHistory).length"
                        class="history-box"
                        :style="isOpenContractHistory"
                      >
                        <div class="flex justify-between">
                          <div class="history-title">История действий</div>
                          <AppIcon
                            src="raw-svg/cross.svg"
                            class="history-icon"
                            @click.native="isOpenContractHistory = {}"
                          />
                        </div>

                        <ContractHistory
                          class="history-list scroll"
                          :style="{ 'max-height': isOpenContractHistory.heightContent }"
                        />
                      </div>
                    </FadeTransaction>
                  </div>
                </div>
              </div>

              <div v-if="hasContractDatesColumn || hasContractTariffColumn" class="tariff-contract-status-meta">
                <div v-if="hasContractDatesColumn" class="tariff-contract-status-col">
                  <div v-if="contractInfo?.outsourcer" class="tariff-contract-status-row">
                    <div class="tariff-contract-status-row__title">Аутсорсер</div>
                    <div class="tariff-contract-status-row__value">{{ contractInfo.outsourcer }}</div>
                  </div>
                  <div v-if="contractInfo?.date" class="tariff-contract-status-row">
                    <div class="tariff-contract-status-row__title">Дата договора</div>
                    <div class="tariff-contract-status-row__value">{{ contractInfo.date | localDate }}</div>
                  </div>
                  <div v-if="contractInfo?.service_date" class="tariff-contract-status-row">
                    <div class="tariff-contract-status-row__title">Начало оказания услуг</div>
                    <div class="tariff-contract-status-row__value">{{ contractInfo.service_date | localDate }}</div>
                  </div>
                </div>

                <div v-if="hasContractTariffColumn" class="tariff-contract-status-col">
                  <div v-if="contractInfo?.tariff?.name" class="tariff-contract-status-row">
                    <div class="tariff-contract-status-row__title">Тариф</div>
                    <div class="tariff-contract-status-row__value">{{ contractInfo.tariff.name }}</div>
                  </div>
                  <div v-if="contractInfo?.taxation?.name" class="tariff-contract-status-row">
                    <div class="tariff-contract-status-row__title">СНО</div>
                    <div class="tariff-contract-status-row__value">{{ contractInfo.taxation.name }}</div>
                  </div>
                  <div v-if="contractInfo?.businessform?.name" class="tariff-contract-status-row">
                    <div class="tariff-contract-status-row__title">Правовая форма</div>
                    <div class="tariff-contract-status-row__value">{{ contractInfo.businessform.name }}</div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>

        <div class="tariff-contract-doc">
          <div ref="docText" class="tariff-contract-text"></div>
          <img v-if="firstPageLoading" src="@icons/bubble-loader.svg" width="40" />
        </div>
      </div>
    </div>

    <div v-else class="tariff-contract-none">
      <div class="tariff-contract-none__icon-wr">
        <AppIcon name="file-clock" class="tariff-contract-none__icon" />
      </div>
      <div class="tariff-contract-none__title">Договор не заключен</div>
      <div class="tariff-contract-none__description">Для заключения договора обратитесь к аутсорсеру</div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { API_URL, STATUSES_CONTRACT } from "../../utils/constants.js"; // CONTRACT_STATUS_NAMES
import * as pdfjsLib from "pdfjs-dist/webpack";
import debounce from "lodash-es/debounce";
import AppIcon from "@/components/common/Icon.vue";
import FileDownloadIcon from "../../components/common/FileDownloadIcon.vue";
import ContractHistory from "../../components/Tariff/ContractHistory.vue";
import FadeTransaction from "../../components/transitions/Fade.vue";
import formatDate from "@/lib/vue-filters/formatDate";
import MarginConfirmationBlock from "@/components/Tariff/MarginConfirmationBlock.vue";
import ContractDocumentSelector from "@/components/Tariff/ContractDocumentSelector.vue";
import { InfoService } from "@/services";

export default {
  name: "TariffContract",

  components: {
    AppIcon,
    FileDownloadIcon,
    ContractHistory,
    FadeTransaction,
    MarginConfirmationBlock,
    ContractDocumentSelector,
  },

  data() {
    return {
      isContractsLoading: true,
      documentLoading: false,
      firstPageLoading: false,
      fullPackDocLoading: false,
      activeDocumentId: null,
      isOpenContractHistory: {},
      pdfPages: [],
      statuses: STATUSES_CONTRACT,
      collectionDocuments: {},
      firstDocument: null,
      contracts: [],
    };
  },

  computed: {
    ...mapGetters("Organizations/ActiveOne", {
      orgId: "getId",
      selectedContractId: "getSelectedContractId",
      contractInfo: "getSelectedContractInfo",
      isContractInfoLoading: "isSelectedContractInfoLoading",
    }),

    isContractDataLoading() {
      return this.isContractsLoading || this.isContractInfoLoading;
    },

    selectedContract() {
      return this.contracts.find((item) => item.contract_id === this.selectedContractId) || null;
    },

    hasContractDatesColumn() {
      return Boolean(this.contractInfo?.outsourcer || this.contractInfo?.date || this.contractInfo?.service_date);
    },

    hasContractTariffColumn() {
      return Boolean(
        this.contractInfo?.tariff?.name || this.contractInfo?.taxation?.name || this.contractInfo?.businessform?.name
      );
    },

    documents() {
      return Array.isArray(this.contractInfo?.documents) ? this.contractInfo.documents : [];
    },

    pinnedDocument() {
      return this.documents?.[0] ?? null;
    },

    contractStatus() {
      const status = this.selectedContract?.contract_status;

      if (status === "service_datenotarrive") {
        return "concluding_await";
      }

      return status;
    },

    contractStatusComponent() {
      const status = this.contractStatus;

      // если договор ожидает подписания и дата начала оказания услуг (НОУ) еще не наступисла, то меняем на дополнительный статус concluding_await (не приходит от 1С)
      if (
        status === "concluding" &&
        this.contractInfo?.service_date &&
        new Date(this.contractInfo.service_date) > new Date()
      ) {
        return "concluding_await";
      } else if (status === "concluding" && this.contractInfo?.is_offer) {
        return "concluding_expect";
      } else if (status === "concluding_await") {
        return "concluding_await";
      } else if (this.statuses[status]) {
        return status;
      }

      return "none";
    },

    statusTextIconName() {
      if (this.contractStatusComponent === "suspended") return "doc-status-suspended";
      if (this.contractStatusComponent === "terminated") return "doc-status-closed";

      return ["service", "concluding_await"].includes(this.contractStatusComponent)
        ? "contract-status-check"
        : "contract-status-clock";
    },

    hasContract() {
      return this.contracts.length > 0;
    },

    archiveDownloadLink() {
      return `${API_URL}/organization/${this.orgId}/document/archive?contract_id=${this.firstDocument?.contract_id}&doc_id=${this.firstDocument?.doc_id}`;
    },
  },

  watch: {
    documents(val) {
      this.firstDocument = val?.[0] ?? null;

      if (!this.firstDocument) {
        this.activeDocumentId = null;
        if (this.$refs.docText) {
          this.$refs.docText.innerHTML = "";
        }
        return;
      }

      this.$nextTick(() => {
        this.showDocument(
          this.firstDocument?.doc_id,
          this.firstDocument?.form_id,
          this.firstDocument?.contract_id,
          this.firstDocument?.guid
        );
      });
    },

    selectedContractId: {
      immediate: true,
      handler(contractId) {
        this.loadContractInfo(contractId);
      },
    },

    orgId() {
      this.loadAllContracts();
    },
  },

  created() {
    this.loadAllContracts();
  },

  methods: {
    formatDate,
    ...mapActions("Organizations/ActiveOne", {
      setSelectedContractId: "setSelectedContractId",
      fetchContractInfo: "fetchContractInfo",
    }),
    ...mapActions("Organizations/ActiveOne/MarginConfirmation", {
      resetMarginConfirmation: "resetState",
    }),

    async loadAllContracts() {
      this.isContractsLoading = true;
      this.contracts = [];

      try {
        if (!this.orgId) {
          this.setSelectedContractId(null);
          return;
        }

        const contracts = await InfoService.fetchAllContracts(this.orgId);
        this.contracts = Array.isArray(contracts) ? contracts : [];

        const serviceContract = this.contracts.find((item) => item.contract_status === "service");
        const selectedId = serviceContract?.contract_id || this.contracts[0]?.contract_id || null;

        this.setSelectedContractId(selectedId);
        await this.$nextTick();
      } catch (e) {
        this.contracts = [];
        this.setSelectedContractId(null);
      } finally {
        this.isContractsLoading = false;
      }
    },

    async loadContractInfo(contractId) {
      this.collectionDocuments = {};
      this.pdfPages = [];
      this.firstDocument = null;
      this.activeDocumentId = null;
      this.resetMarginConfirmation();

      if (!contractId) {
        return;
      }

      await this.fetchContractInfo(contractId);
    },

    showDocument(doc_id, form_id, contract_id, guid) {
      if (!doc_id || !this.$refs.docText || this.documentLoading) {
        return;
      }

      this.pdfPages = [];
      window.removeEventListener("resize", this.rerenderPages);
      window.addEventListener("resize", this.rerenderPages);

      this.documentLoading = true;
      this.firstPageLoading = true;
      this.activeDocumentId = guid;

      const docUrl = `${API_URL}/organization/${this.orgId}/document/file?contract_id=${contract_id}&doc_id=${doc_id}&form_id=${form_id}`;
      let loadingTask = null;
      if (guid in this.collectionDocuments) {
        loadingTask = this.collectionDocuments[guid];
      } else {
        loadingTask = pdfjsLib.getDocument({
          url: docUrl,
          withCredentials: true,
        });
        this.collectionDocuments[guid] = loadingTask;
      }

      this.$refs.docText.innerHTML = "";

      loadingTask.promise
        .then((doc) => {
          const numPages = doc.numPages;

          let lastPromise = doc.getMetadata(); // return promise

          const loadPage = (pageNum) => {
            return doc
              .getPage(pageNum)
              .then((page) => {
                let renderTask = null;
                let initialViewport = page.getViewport({ scale: 1 });
                let initialWidth = initialViewport.width;
                const canvas = document.createElement("canvas");
                const context = canvas.getContext("2d");
                canvas.style.display = "block";

                if (pageNum === 1) {
                  this.firstPageLoading = false;
                }

                const pageObj = {
                  initialWidth: initialWidth,
                  page: page,
                  renderTask: renderTask,
                  canvas: canvas,
                  context: context,
                };

                this.pdfPages.push(pageObj);

                this.renderPage(pageObj);

                this.$refs.docText.appendChild(canvas);
              })
              .catch((error) => {
                console.log(error, "error getPage");
              });
          };

          for (let i = 1; i <= numPages; i++) {
            lastPromise = lastPromise.then(loadPage.bind(null, i));
          }

          return lastPromise;
        })
        .then(
          () => {
            this.documentLoading = false;
          },
          (err) => {
            this.documentLoading = false;
            console.error("Error: " + err);
          }
        )
        .catch((error) => {
          console.log(error, "error loadPage");
        });
    },

    renderPage(pageObj) {
      const scale = (this.$refs.docText.offsetWidth - 20) / pageObj.initialWidth;
      const viewport = pageObj.page.getViewport({ scale: scale });
      pageObj.canvas.height = viewport.height;
      pageObj.canvas.width = viewport.width;

      if (pageObj.renderTask) {
        pageObj.renderTask.cancel();
        pageObj.renderTask = null;
      }

      pageObj.renderTask = pageObj.page.render({
        canvasContext: pageObj.context,
        viewport: viewport,
      });

      pageObj.renderTask.promise
        .then(() => {
          pageObj.renderTask = null;
        })
        .catch((error) => {
          if (error.name === "RenderingCancelledException") {
            return;
          }
        });
    },

    openContractHistory(event) {
      let maxHeightBlock = this.$el.getBoundingClientRect().bottom - event.clientY - 50;
      let heightBlock = maxHeightBlock > 488 ? 488 : maxHeightBlock;

      this.isOpenContractHistory = {
        top: `${event.clientY + 30}px`,
        left: `${event.clientX - 220}px`,
        "max-height": (maxHeightBlock > 488 ? 488 : maxHeightBlock) + "px",
        heightContent: heightBlock - 88 + "px",
      };
    },

    downloadFile() {
      this.fullPackDocLoading = true;
      InfoService.fetchDownloadFile(this.archiveDownloadLink)
        .finally(() => (this.fullPackDocLoading = false))
        .catch((error) => {
          this.$notify({
            type: "error",
            text: error.message || error.error,
          });
        });
    },

    rerenderPages: debounce(function () {
      if (!this.$refs.docText) {
        return;
      }

      for (const pageObj of this.pdfPages) {
        this.renderPage(pageObj);
      }
    }, 300),
  },
};
</script>

<style scoped lang="scss">
/* stylelint-disable selector-class-pattern */
.tariff-contract {
  display: flex;
  flex-wrap: wrap;
  padding: 12px 24px 24px;
}

.tariff-contract-wrapper {
  display: flex;
  width: 100%;
  height: 100%;
}

.tariff-contract-aside {
  width: 307px;
  flex: none;
  margin-right: 24px;

  &__confirmation {
    margin-bottom: 24px;
  }

  &__card {
    border-radius: 8px;
    background: #fff;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.12);
    overflow: hidden;
    margin-bottom: 15px;
    padding-bottom: 12px;
  }

  &__loader-overlay {
    display: flex;
    width: 100%;
    height: 300px;
  }

  &__loader-icon {
    display: block;
    margin: auto;
  }

  &__divider {
    height: 1px;
    background: #dfdfdf;
    border: none;
    margin: 12px auto;
    width: calc(100% - 24px);
  }
}

.tariff-contract-documents {
  overflow: auto;
  max-height: 570px;
  padding-top: 20px;
}

.tariff-contract-documents--disabled {
  opacity: 0.7;
  pointer-events: none;
}

.tariff-contract-document {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  color: #1c1c1c;
  cursor: pointer;
  font-size: 18px;
  line-height: 22px;

  &.all {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 4px 12px 18px;
    border-radius: 10px;
    border-bottom: none;
    transition: 0.3s;
    color: var(--text-text-primary, #0d0d0d);
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 128.571% */

    &:hover {
      background-color: #f6f6f6;
    }
  }

  img {
    margin-left: 5px;
  }

  &__body {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    padding: 6px 12px;
    transition: 0.3s;

    &:hover {
      background-color: #f6f6f6;
    }

    &__title {
      display: flex;
      flex-direction: column;
      color: var(--text-text-primary, #0d0d0d);
      font-family: Roboto, sans-serif;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }

    &__subtitle {
      display: inline-block;
      margin-top: 6px;
      color: var(--border-border-field-hover, #868686);
      font-family: Roboto, sans-serif;
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }

  &__details {
    display: flex;
    width: 100%;
    align-items: center;
    padding: 6px 12px 6px 18px;
    border-radius: 10px;
    transition: 0.3s;

    &__notify {
      flex: none;
      width: 5px;
      height: 5px;
      border-radius: 50%;
      margin-right: 8px;
      background: #04c200;
      visibility: hidden;

      &.visible {
        visibility: visible;
      }
    }

    &__title {
      color: var(--text-text-secondary, #555);
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px; /* 128.571% */
    }

    &:hover {
      background-color: #f6f6f6;
    }
  }
}

.tariff-contract-document--active {
  border-bottom: none;
  background-color: #f6f6f6;
  font-weight: 700;
}

.tariff-contract-document-icon {
  width: 16px;
  margin-left: auto;
  color: #848484;

  &:hover {
    color: #6b6b6b;
  }
}

.tariff-contract-documents-all {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 12px;
  cursor: pointer;
  transition: 0.3s;
  color: var(--link-link-secondary, #4583bb);
  font-family: Arial, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0.16px;

  &:hover {
    background-color: #f0f6fb;
  }

  img {
    margin-left: 6px;
  }

  &__loader {
    margin-left: 6px;
    filter: none;
  }
}

.tariff-contract-main {
  display: flex;
  width: 100%;
  flex-direction: column;
  margin-top: -8px;
}

.tariff-contract-info {
  flex: none;
  margin: 8px 0 20px;
}

.tariff-contract-status {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 40px;
  padding: 11px 24px;
  border-radius: 8px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.12);
  margin: 6px;

  &__loader {
    display: flex;
    width: 100%;
    min-height: 64px;
    align-items: center;
    justify-content: center;
  }

  &__loader-icon {
    display: block;
  }
}

.tariff-contract-status-col {
  display: grid;
  min-width: max-content;
  flex: 1 0 auto;
  align-items: center;
  column-gap: 25px;
  grid-template-columns: max-content minmax(0, 1fr);
  row-gap: 10px;

  &--status {
    display: flex;
    flex: 1 0 auto;
    flex-direction: row;
    align-items: center;
    gap: 0;
    min-width: 0;
  }
}

.tariff-contract-status-meta {
  --meta-two-col-min: 48rem;

  display: flex;
  flex: 1 1 auto;
  flex-wrap: wrap;
  align-items: center;
  gap: 40px;
  min-width: min(100%, var(--meta-two-col-min));

  > .tariff-contract-status-col {
    flex-grow: 1;
    flex-shrink: 0;
    flex-basis: calc((var(--meta-two-col-min) - 100%) * 999);
  }
}

.tariff-contract-status-icon {
  width: 64px;
  height: 64px;
  flex: none;
  margin-right: 24px;
}

.tariff-contract-status-text {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  font-weight: 700;
}

.tariff-contract-status-text-icon {
  width: 20px;
  height: 20px;
  flex: none;
}

.tariff-contract-status-row {
  display: contents;

  &__title {
    color: #848484;
    font-family: Roboto, sans-serif;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0;
    line-height: 102%;
    white-space: nowrap;
  }

  &__value {
    color: #1c1c1c;
    font-family: Roboto, sans-serif;
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0;
    line-height: 120%;
  }
}

.tariff-contract-history-link {
  position: relative;
  color: #528fc9;
  cursor: pointer;
  font-size: 14px;
  line-height: 16px;
  text-decoration: underline;
  transition: 0.3s;

  &:hover {
    color: #044291;
    text-decoration: none;
  }
}

.history-box {
  position: fixed;
  z-index: 9;
  overflow: hidden;
  width: 400px;
  padding: 15px 5px 15px 24px;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 0 6px 2px rgba(0, 0, 0, 0.12);
  color: #1c1c1c;
  cursor: default;
}

.history-title {
  font-size: 24px;
  font-weight: 500;
  line-height: 28px;
}

.history-icon {
  margin-right: 20px;
  cursor: pointer;

  ::v-deep svg path {
    transition: 0.3s;
  }

  ::v-deep &:hover svg path {
    fill: #ccc;
  }
}

.history-list {
  padding-right: 15px;
  margin-top: 30px;
}

.tariff-contract-doc {
  position: relative;
  display: flex;
  flex: 1 1 0%;
  align-items: center;
  justify-content: center;

  & > img {
    position: absolute;
  }
}

.tariff-contract-text {
  width: 100%;

  ::v-deep canvas {
    margin: 6px auto;
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.12);
  }
}

.tariff-contract-none {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &__icon-wr {
    display: flex;
    width: 190px;
    height: 190px;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    margin-bottom: 30px;
    background-color: #ebebeb;
  }

  &__icon {
    color: #b7b7b7;
  }

  &__title {
    margin-bottom: 10px;
    color: #333;
    font-size: 26px;
    font-weight: 500;
    line-height: 34px;
    text-align: center;
  }

  &__description {
    max-width: 400px;
    color: #848484;
    font-size: 18px;
    line-height: 25px;
    text-align: center;
  }
}

.scroll--rounded {
  &::-webkit-scrollbar-thumb {
    border-top: 10px solid #fff;
    border-bottom: 10px solid #fff;
  }
}

.relative {
  position: relative;
  margin-top: 8px;
  margin-left: 4px;

  @media (max-width: 1085px) {
    & {
      margin-left: 0;
    }
  }
}

.flex {
  display: flex;
}

.justify-between {
  justify-content: space-between;
}
</style>
